import React from 'react';
import PropTypes from 'prop-types';

import styles from './collapsible.scss';

const Collapsible = (props) => {
    const { isOpen, children, onClick, className, 'data-testid': dataTestId } = props;
    return (
        <div className={`${styles.collapsible} ${className}`} onClick={onClick} data-testid={dataTestId}>
            <div className={styles.icon} data-testid={dataTestId && `${dataTestId}.icon`}>
                <i className={`fas fa-solid fa-caret-${isOpen ? 'down' : 'right'}`} />
            </div>
            <div className={styles.content} data-testid={dataTestId && `${dataTestId}.content`}>
                {children}
            </div>
        </div>
    );
};

Collapsible.propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.element.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};

Collapsible.defaultProps = {
    isOpen: true,
    className: '',
    'data-testid': undefined,
};

export default Collapsible;
